<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field
          slot="cv_date"
          :label="customLabel.cv_date || '拜访日期'"
          v-model="form.main.cv_date"
        />
        <customer-search-box
          slot="cv_custname"
          :label="customLabel.cv_custname || '客户名称'"
          placeholder="请输入或选择客户名称"
          v-model="form.main.cv_custname"
          audit-status="UNAUDITED"
          @onchange="custChange"
          @select="onSelectCustomer"
        />
        <customer-ct-search-box
          slot="cv_contect"
          :label="customLabel.cv_contect || '被访人'"
          placeholder="请输入或选择被访人"
          v-model="form.main.cv_contect"
          @select="onSelectCustomerCt"
          :customer-id="form.main.cv_custid"
        />
        <div class="weui-cell" slot="cv_position">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cv_position || "被访人职务"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cv_position"
              placeholder="请输入..."
            />
          </div>
        </div>
        <div class="weui-cell" slot="cv_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cv_tel || "被访人电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cv_tel"
              placeholder="请输入..."
            />
          </div>
        </div>
        <date-field
          slot="cv_nextdate"
          :label="customLabel.cv_nextdate || '下次拜访日期'"
          v-model="form.main.cv_nextdate"
        />
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="cv_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cv_type || "拜访类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.cv_type"
              placeholder="请选择"
            >
              <option>上门拜访</option>
              <option>电话拜访</option>
            </select>
          </div>
        </div>
        <combo-search-box
          slot="cv_useprod"
          :label="customLabel.cv_useprod || '拜访目的'"
          placeholder="请选择或输入拜访目的"
          v-model="form.main.cv_useprod"
          url="/api/document/productuse/getCombo"
          ref="combo"
        />
        <vendor-field
          slot="cv_vendname"
          :label="'开放给原厂'"
          :isNeedInput="true"
          @onchange="vendChange"
          v-model="form.main.cv_vendname"
          @select="onSelectVend"
          v-config-if="'isDistributor'"
        />
        <!-- isDistributor: 按配置显示开放原厂 -->
        <div slot="cv_remark">
          <div
            class="weui-cells__title"
            style="font-size: 17px; color: var(--weui-FG)"
          >
            {{ customLabel.cv_remark || "访问记录" }}
          </div>
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  v-model="form.main.cv_remark"
                  placeholder="请输入..."
                  rows="3"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items1"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>业务状态{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <combo-field
            ref="combo2"
            slot="cvd_brand"
            :label="customLabel.cvd_brand || '厂家/品牌'"
            v-model="item.cvd_brand"
            url="/api/document/productbrand/getCombo"
          />
          <product-field
            slot="cvd_orispeccode"
            :label="customLabel.cvd_orispeccode || '型号'"
            v-model="item.cvd_orispeccode"
            @select="onSelectProduct($event, item)"
          />
          <combo-field
            ref="combo1"
            slot="cvd_businessstauts"
            :label="customLabel.cvd_businessstauts || '状态'"
            v-model="item.cvd_businessstauts"
            url="/api/document/businessstatus/getCombo"
          />
          <div class="weui-cell" slot="cvd_projectname">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.cvd_projectname || "客户项目名称"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.cvd_projectname"
                placeholder="请填写"
              />
            </div>
          </div>

          <custom-field
            :label="customLabel.cvd_text1 || '自定义字段1'"
            v-model="item.cvd_text1"
            :caller="caller"
            fieldName="cvd_text1"
            slot="cvd_text1"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text2 || '自定义字段2'"
            v-model="item.cvd_text2"
            :caller="caller"
            fieldName="cvd_text2"
            slot="cvd_text2"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text3 || '自定义字段3'"
            v-model="item.cvd_text3"
            :caller="caller"
            fieldName="cvd_text3"
            slot="cvd_text3"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text4 || '自定义字段4'"
            v-model="item.cvd_text4"
            :caller="caller"
            fieldName="cvd_text4"
            slot="cvd_text4"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text5 || '自定义字段5'"
            v-model="item.cvd_text5"
            :caller="caller"
            fieldName="cvd_text5"
            slot="cvd_text5"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text6 || '自定义字段6'"
            v-model="item.cvd_text6"
            :caller="caller"
            fieldName="cvd_text6"
            slot="cvd_text6"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text7 || '自定义字段7'"
            v-model="item.cvd_text7"
            :caller="caller"
            fieldName="cvd_text7"
            slot="cvd_text7"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text8 || '自定义字段8'"
            v-model="item.cvd_text8"
            :caller="caller"
            fieldName="cvd_text8"
            slot="cvd_text8"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text9 || '自定义字段9'"
            v-model="item.cvd_text9"
            :caller="caller"
            fieldName="cvd_text9"
            slot="cvd_text9"
            hidden="true"
          />

          <custom-field
            :label="customLabel.cvd_text10 || '自定义字段10'"
            v-model="item.cvd_text10"
            :caller="caller"
            fieldName="cvd_text10"
            slot="cvd_text10"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text11 || '自定义字段11'"
            v-model="item.cvd_text11"
            :caller="caller"
            fieldName="cvd_text11"
            slot="cvd_text11"
            hidden="true"
          />
          <custom-field
            :label="customLabel.cvd_text12 || '自定义字段12'"
            v-model="item.cvd_text12"
            :caller="caller"
            fieldName="cvd_text12"
            slot="cvd_text12"
            hidden="true"
          />
        </custom-layout>
      </div>
      <div class="weui-cells">
        <a href="javascript:" class="weui-cell weui-cell_link" @click="addItem">
          <div class="weui-cell__bd">添加业务状态</div>
        </a>
      </div>

      <div class="weui-cells">
        <file-field v-model="form.main.cv_attach" />
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd visit-record-reply">
          <p>拜访历史</p>
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in history"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail3">
            <div class="weui-form-preview__item" slot="cv_code">
              <label class="weui-form-preview__label">{{
                customLabel.cv_code || "单据编号"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_code }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_date">
              <label class="weui-form-preview__label">{{
                customLabel.cv_date || "拜访日期"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                v-format="'yyyy-MM-dd'"
                >{{ item.cv_date }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="creatorName">
              <label class="weui-form-preview__label">{{
                customLabel.creatorName || "访问人"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.creatorName }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dp_name">
              <label class="weui-form-preview__label">{{
                customLabel.dp_name || "部门"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.dp_name }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_contect">
              <label class="weui-form-preview__label">{{
                customLabel.cv_contect || "被访人"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_contect }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_position">
              <label class="weui-form-preview__label">{{
                customLabel.cv_position || "被访人职务"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_position }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_tel">
              <label class="weui-form-preview__label">{{
                customLabel.cv_tel || "被访人电话"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_tel }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_nextdate">
              <label class="weui-form-preview__label">{{
                customLabel.cv_nextdate || "下次拜访日期"
              }}</label>
              <span
                v-if="item.cv_nextdate"
                class="weui-form-preview__value weui-form-preview__value-icon"
                v-format="'yyyy-MM-dd'"
                >{{ item.cv_nextdate }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_useprod">
              <label class="weui-form-preview__label">{{
                customLabel.cv_useprod || "拜访目的"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_useprod }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_vendname">
              <label class="weui-form-preview__label">{{
                customLabel.cv_vendname || "开放给原厂"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_vendname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_remark">
              <label class="weui-form-preview__label">{{
                customLabel.cv_remark || "访问记录"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_remark }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_detno">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_detno || "序号"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_detno }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_brand">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_brand || "品牌"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_brand }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_orispeccode">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_orispeccode || "型号"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_orispeccode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_businessstauts">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_businessstauts || "状态"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_businessstauts }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_projectname">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_projectname || "客户项目名称"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_projectname }}
              </span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import CustomerSearchBox from "@/components/field/CustomerSearchBox.vue";
import CustomerCtSearchBox from "@/components/field/CustomerCtSearchBox.vue";
import process from "@/mixins/process.js";
import VendorField from "@/components/field/VendorField.vue";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import ProductField from "@/components/field/ProductField.vue";
import ComboField from "@/components/field/ComboField.vue";
import FileField from "@/components/field/FileField.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    DateField,
    CustomerSearchBox,
    CustomerCtSearchBox,
    VendorField,
    ComboSearchBox,
    ProductField,
    ComboField,
    FileField,
    CustomField,
  },
  data() {
    return {
      baseUrl: "/api/crm/clientvisit",
      codeField: "cv_code",
      statusField: "cv_statuscode",
      caller: "ClientVisit",
      xtype: "crm-clientvisit-formpanel",
      form: {
        main: {
          cv_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          cv_custid: 0,
          cv_tel: "",
          cv_type: "上门拜访",
        },
        items1: [
          {
            cvd_detno: null,
            cvd_brand: "",
            cvd_orispeccode: "",
            cvd_businessstauts: "",
            cvd_projectname: "",
          },
        ],
      },
      history: [],
    };
  },
  mounted() {
    const me = this,
      main = me.form.main;
    if (!me.initId && !me.initData) {
      me.$loading({
        url: "/api/document/employee/read/current",
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          if (data.main) {
            main.creatorId = data.main.accountId;
            main.creatorName = data.main.em_name;
          }
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  },
  methods: {
    getHistory() {
      let me = this,
        form = me.form,
        main = form.main;

      let params = {
        cv_custname: main.cv_custname,
        creatorId: main.creatorId,
      };
      me.$ajax({
        url: "/api/crm/clientvisit/listByCu",
        params,
      }).then(function (res) {
        if (res.success) {
          if (!main.id) {
            form.items1 = res.data.details1;
          }
          me.history = res.data.details2;
        }
      });
    },

    f_afterload() {
      // this.form.items1.reverse();
      this.getHistory();
    },
    /**
     * 选择明细产品
     */
    onSelectProduct(selection, item) {
      item.cvd_orispeccode = selection.pr_orispeccode;
      item.cvd_brand = selection.pr_brand;
    },
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.cv_custname = selection.cu_name;
      main.cv_custid = selection.id;
      main.cv_custcode = selection.cu_code;
      main.cv_contect = selection.cc_name;
      main.cv_address = selection.ca_address;
      main.cv_tel = selection.cc_tel;
      main.cv_position = selection.cc_job;
      me.getHistory(); 
     
    },
    /* 
      手动输入客户时置空id和code
    */
    custChange() {
      var me = this,
        main = me.form.main;
      main.cv_custid = null;
      main.cv_custcode = null;
    },
    onSelectCustomerCt(selection) {
      var me = this,
        main = me.form.main;
      main.cv_contect = selection.cc_name;
      main.cv_tel = selection.cc_tel;
    },
    onSelectVend(selection) {
      var me = this,
        main = me.form.main;
      main.cv_venduu = selection.ve_uu;
    },
    vendChange(value) {
      var me = this,
        main = me.form.main;
      main.cv_vendname = value;
      main.cv_venduu = null;
    },
    prod_combo_save(cv_useprod) {
      var me = this;
      let combo = me.$refs.combo.data,
        save = combo.some((item) => {
          return item.value == cv_useprod;
        });
      if (!save) {
        me.$ajax({
          url: "/api/document/productuse/save",
          method: "POST",
          jsonData: {
            pu_name: cv_useprod,
            id: 0,
          },
        }).then();
      }
    },
    removeItem(index) {
      var me = this,
        items1 = me.form.items1;

      items1.splice(index, 1);
    },
    addItem() {
      var me = this,
        items1 = me.form.items1;
      items1.push({});
    },
    save() {
      var me = this,
        main = me.form.main,
        items1 = me.form.items1;
      if (!main.cv_date) {
        me.$weui.topTips("请选择日期", 2000);
      } else if (!main.cv_custname) {
        me.$weui.topTips("请填写或选择客户", 2000);
      } else if (!main.cv_contect) {
        me.$weui.topTips("请填写或选择被访人", 2000);
      } else if (!main.cv_tel) {
        me.$weui.topTips("请填写联系人电话", 2000);
      } else if (me.form.main.cv_useprod) {
        me.prod_combo_save(me.form.main.cv_useprod);
        me.p_save();
      } else {
        var count = 0;
        items1.forEach(function (item) {
          count++;
          item.cvd_detno = count;
        });

        me.p_save();
      }
    },
  },
};
</script>